import { Divider, Drawer, IconButton } from "@mui/material";
import { memo, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Icon, NavLink } from "../../common/components";
import { OverlayScrollbarWrapper } from "../../common/components/OverlayScrollbar";
import { useSelector } from "../../common/hooks/useSelector";
import { TenantLogo } from "../../components/TenantLogo";
import { AppToolbarContext } from "../../context/AppToolbar";
import { palette, spacing } from "../../styles/theme";
import { ROUTES } from "../../constant/common.constant";
import { AddTeamNavItem } from "./AddTeamNavItem";
import styles from "./LeftNavigation.module.scss";
import { SearchTeams } from "./SearchTeams";
import { TeamProjects } from "./TeamProjects";
import { UserProfileDrawerContent, UserProfileNavLink } from "./UserProfile";

const LeftNavigationMobile = () => {
  const userInfos = useSelector((state) => state.userInfo);
  const { t } = useTranslation();
  const [view, setView] = useState<"base" | "userProfile">("base");
  const { isNavigationDrawerOpen, toggleNavigationDrawerOpen } =
    useContext(AppToolbarContext);

  return (
    <Drawer
      open={isNavigationDrawerOpen}
      onClose={toggleNavigationDrawerOpen}
      classes={{ paper: styles.drawer }}
    >
      {view === "base" ? (
        <OverlayScrollbarWrapper>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems={"center"}
            px={spacing.wrapperMobile}
            py={1.5}
            mb={spacing.wrapperMobile}
          >
            <TenantLogo />
            <IconButton onClick={toggleNavigationDrawerOpen}>
              <Icon icon="close" size={24} color={palette.grey.nearBlack} />
            </IconButton>
          </Box>
          <Box className={styles.container} px={spacing.wrapperMobile}>
            <UserProfileNavLink onClick={() => setView("userProfile")} />
            <NavLink
              startIcon={"home"}
              content={t("navigation.home")}
              onClick={toggleNavigationDrawerOpen}
              to={ROUTES.HOME}
              clickableLink
            />

            <NavLink
              to={ROUTES.TEMPLATES}
              onClick={toggleNavigationDrawerOpen}
              startIcon={"web_traffic"}
              content={t("navigation.templates")}
              clickableLink
            />

            {userInfos && (userInfos.isAdmin || userInfos.isDesigner) && (
              <SearchTeams />
            )}

            {userInfos.canAddTeam && <AddTeamNavItem />}

            <Divider />

            <div className={styles.teams} data-test="leftNavigation.teams">
              <TeamProjects canAddProject={userInfos.canAddProject} />
            </div>
          </Box>
        </OverlayScrollbarWrapper>
      ) : (
        <UserProfileDrawerContent onBackClick={() => setView("base")} />
      )}
    </Drawer>
  );
};

export default memo(LeftNavigationMobile);
